import axios from 'axios'

const BASE_URL = (window.env && window.env.baseHost) || ''

export const api = axios.create({
  baseURL: BASE_URL
})
